module.exports = __webpack_public_path__ + "fonts/SuisseIntl-SemiBold.e7282ff.woff";